module.exports = __webpack_public_path__ + "static/media/The_Hat.10e97da9.png";